<script>
	import { slide } from "svelte/transition";

	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../tealium";
	import { projectSettings, dropZoneOptions } from "../../config";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	// props
	export let persistUrl = null;
	export let pageName = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;

	const options = dropZoneOptions($model.registrationToken);

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const initialise = () => {
		$model.photoIdDocumentList = $model.photoIdDocumentList || [];
		$model.otherIdDocumentList = $model.otherIdDocumentList || [];
	};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="your-id-details" on:submit={handleSubmit}>
		<FormRowColumn rowClass="justify-content-center confirmation-hide">
			<h4 class="text-center">
				{@html projectSettings.classActionName}
			</h4>
			<h1 class="text-center">Part 2: Your ID</h1>
		</FormRowColumn>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<FormRowColumn>
				<YesNoGroup
					required
					{disabled}
					name="photoId"
					label="Do you have photo ID? For example, a Driver's Licence (including Learner's Permit), Photo Card (Evidence of Age Card), or Passport. You can give photo ID which is current or has expired within the last five (5) years."
					bind:value={$model.claimDetails.photoId}
				/>
			</FormRowColumn>

			{#if $model.claimDetails.photoId == "Yes"}
				<div transition:slide|local>
					<p>Please upload a copy of the photo ID (do not post original).</p>

					<FormRowColumn>
						<DropZone
							{disabled}
							{options}
							id="dz_photo_id"
							filenamePrefix="PHOTO_ID_"
							bind:documentList={$model.photoIdDocumentList}
						></DropZone>
					</FormRowColumn>
				</div>
			{/if}

			{#if $model.claimDetails.photoId == "No"}
				<div transition:slide|local>
					<FormRowColumn>
						<YesNoGroup
							required
							{disabled}
							name="otherId"
							label="If you do not have photo ID, do you have two types of other ID? For example, copies of a Birth Certificate, Marriage Certificate, Medicare Card, Concession Card, Health Care Card, Bank Card (Key Card), bank account statement, electricity bill, or Tenancy Agreement."
							bind:value={$model.claimDetails.otherId}
						/>
					</FormRowColumn>

					{#if $model.claimDetails.otherId == "Yes"}
						<div transition:slide|local>
							<p>
								Please upload copies of your two forms of ID to this Registration Form (do not post
								originals), or you can send your ID by text message, email or post (see below).
							</p>

							<FormRowColumn>
								<DropZone
									{disabled}
									{options}
									id="dz_other_id"
									filenamePrefix="OTHER_ID_"
									bind:documentList={$model.otherIdDocumentList}
								></DropZone>
							</FormRowColumn>
						</div>
					{/if}
				</div>
			{/if}

			<p class="bold">Sending Your ID</p>
			<p class="bold">You can also send your ID to Shine Lawyers by:</p>
			<ul>
				<li>Taking a photo and texting it to 0461 364 522;</li>
				<li>Taking a photo and emailing to {projectSettings.emailAddress}; OR</li>
				<li>
					Taking a copy and posting it Shine Lawyers, Class Actions - NT Stolen Wages Class Action, PO BOX
					12011, George Street QLD 4000
				</li>
			</ul>
			<p>
				If you need to speak to Shine Lawyers, please call them on <b>{projectSettings.phoneNumber}</b>, not the
				mobile phone number
			</p>
		</div>

		<FormRowColumn rowClass="confirmation-hide">
			<NavigationButtons bind:buttons />
		</FormRowColumn>
	</Form>
</PageSection>

<style>
</style>
